module.exports = __webpack_public_path__ + "img/logo.c695e49b.png";